import * as React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

export const ButtonWithTooltip = ({
    onClick,
    id,
    icon,
    title,
    buttonStyle,
    disabled
}: {
    onClick: () => void;
    id: string;
    icon: React.ReactNode;
    title: string;
    buttonStyle: string;
    disabled?: boolean;
}) => {
    return (
        <>
            <button type="text" className={buttonStyle} onClick={() => onClick()} id={id} disabled={disabled}>
                {icon}
            </button>
            <UncontrolledTooltip placement="top" target={id} delay={0} className="tooltipstrap">
                {title}
            </UncontrolledTooltip>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/ButtonWithTooltip.tsx